import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserSettingsFormComponent } from './user-settings-form/user-settings-form.component';
import { CitywireInternalAccountsGuard } from '@tpapa/citywire-internal-accounts-angular';

const routes: Routes = [
  {
    path: '',
    component: UserSettingsFormComponent,
    canActivate: [CitywireInternalAccountsGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserSettingsRoutingModule {}
